module.exports = __webpack_public_path__ + "img/Ail.3b9b8ca2.png";